/**
 * Created by Dave on 09.11.2015.
 
 * Modified by rob@robwatkiss.com on 03.03.2018
 
 * Modifications made to get Variant Image Penguin to play nicely with Swatches and slickSlider

 */

window.stubbleVariants = window.stubbleVariants || {};
jQuery(function () {
  (function (stubbleVariants, $) {
    /*Only run on product page*/
    if (!stubbleVariants.loaded && window.location.href.indexOf("/products/") > -1) {      
      /*override the Standard onVariantChange*/
      if (Shopify.OptionSelectors != undefined) {
        Shopify.OptionSelectors.HistoryState.prototype.onVariantChange = function (t, e, n) {
          try {
            this.browserSupports() && (!t || n.initialLoad || n.popStateCall || Shopify.setParam("variant", t.id));
          }
          catch (err) {

          }
          if (t) {
            if (false) {
              //only do callback when mappings are loaded
              stubbleVariants.variantsInfoReady.done(function () {
                //if event gets triggered by external source, clear the internal Trigger
                stubbleVariants.oldmechanism = true;
                clearInterval(stubbleVariants.triggerInterval);
                stubbleVariants.stubbleVariants_VariantChange_Callout(t.id);
              });
            }
          }
        }
      }

      try {
        $(document).on('variantImageChange', function (event) {
          //if oldmechanism still works just return
          if (stubbleVariants.oldmechanism) {
            return;
          }

          //if event gets triggered by external source, clear the internal Trigger
          if (!event.internalVIPTrigger && stubbleVariants.triggerInterval) {
            clearInterval(stubbleVariants.triggerInterval);
          }
          stubbleVariants.variantsInfoReady.done(function () {
            stubbleVariants.stubbleVariants_VariantChange_Callout(event.variant.id);
          });

        });

      }
      catch (err) {
        console.log(err);
      }


    }
    stubbleVariants.all_mappings = [];
    stubbleVariants.is_running = false;

    stubbleVariants.callVariantChange = function (variantId) {
      if (false) {
        //only do callback when mappings are loaded
        stubbleVariants.variantsInfoReady.done(function () {
          stubbleVariants.stubbleVariants_VariantChange_Callout(variantId);
        });
      }
    };

    //*************************************
    //The MAIN IMAGE HIDING FUNCTION
    //************************************
    stubbleVariants.stubbleVariants_VariantChange_Callout = function (variantId) {
      stubbleVariants.is_running = true;
      if (typeof stubbleVariants.BeforeVariantChange != 'undefined') {
        stubbleVariants.BeforeVariantChange();
      }
      $(document).trigger("VIP:FilterStart");

      stubbleVariants.ImagesShownPromises = [];
      var customSelector = '#ProductThumbs';
      var $toFadeOut = '';

      //Dont do anything if no mapping is provided
      if (stubbleVariants.variants[variantId] == null || stubbleVariants.variants[variantId].length == 0) {
        stubbleVariants.showAllVariantImages();
        $(document).trigger("VIP:FilterComplete", [variantId]);
        return;
      }

      if ($(customSelector).children('img').length > 0) {
        $toFadeOut = $(customSelector).children('img:visible');
      }
      else {
        $toFadeOut = $(customSelector).find('img').parentsUntil(customSelector, ':visible');
      }


      if ($toFadeOut.length > 0) {
        var shown = false;
        $toFadeOut.fadeOut(150).promise().done(function () {
          if (!shown) {
            showVariantImages(variantId);
            shown = true;

            $.when.apply(null, stubbleVariants.ImagesShownPromises).done(function () {
              if (typeof stubbleVariants.VariantChangeCallback != 'undefined') {
                stubbleVariants.VariantChangeCallback();
              }
              $(document).trigger("VIP:FilterComplete", [variantId]);
              stubbleVariants.is_running = false;
            });
          }
        });
      }
      else {
        showVariantImages(variantId);
        stubbleVariants.is_running = false;
      }
    }

    /*manual call for using in collectionpages etc.*/
    stubbleVariants.switchImages = function (productId, variantId, container) {
      stubbleVariants.is_running = true;
      if (typeof stubbleVariants.BeforeVariantChange != 'undefined') {
        stubbleVariants.BeforeVariantChange();
      }
      $(document).trigger("VIP:FilterStart");


      $.when(loadVariantsForProduct(Shopify.shop, productId)).done(function () {
        stubbleVariants.ImagesShownPromises = [];
        var customSelector = container;
        var $toFadeOut = '';

        //Dont do anything if no mapping is provided
        if (stubbleVariants.all_mappings[productId][variantId] == null || stubbleVariants.all_mappings[productId][variantId].length == 0) {
          stubbleVariants.showAllVariantImages();
          $(document).trigger("VIP:FilterComplete", [productId, variantId, container]);
          return;
        }

        if ($(customSelector).children('img').length > 0) {
          $toFadeOut = $(customSelector).children('img:visible');
        }
        else {
          $toFadeOut = $(customSelector).find('img').parentsUntil(customSelector, ':visible');
        }


        if ($toFadeOut.length > 0) {
          var shown = false;
          $toFadeOut.fadeOut(150).promise().done(function () {
            if (!shown) {
              stubbleVariants.currentSelector = container;
              showVariantImagesForProduct(variantId, productId);
              shown = true;

              $.when.apply(null, stubbleVariants.ImagesShownPromises).done(function () {
                if (typeof stubbleVariants.VariantChangeCallback != 'undefined') {
                  stubbleVariants.VariantChangeCallback(container);
                }
                $(document).trigger("VIP:FilterComplete", [productId, variantId, container]);
                stubbleVariants.is_running = false;
              });
            }
          });
        }
        else {
          showVariantImagesForProduct(variantId, productId);
          stubbleVariants.is_running = false;
        }
      });
    }

    var loadVariants = function (shop) {
      return loadVariantsForProduct(shop, $('[data-product-id]').data('product-id'));
    }
    var loadVariantsForProduct = function (shop, productId) {
      if (typeof stubbleVariants.all_mappings[productId] == 'undefined') {
        return $.ajax({
          type: "GET",
          url: "/apps/VIG/liquid_factory/variantsmetatags",
          data: { "handle": window.location.pathname.substr(window.location.pathname.lastIndexOf('/') + 1), "shop": shop, "productid": productId },
          dataType: "script",
          success: function (data) {
            var response = data.replace(/VIG/g, "stubbleVariants");
            response = response.replace("var stubbleVariants = stubbleVariants", "var stubbleVariants = window.stubbleVariants");
            eval(response);
          }
        });
      }
      else {
        return jQuery.Deferred().resolve();
      }
    }
    //load Variants
    stubbleVariants.variantsInfoReady = loadVariants(Shopify.shop);


    //Fix for line breaking images
    $('#ProductThumbs .grid__item').css('clear', 'none');

    var init = function () {
      // Initially hide all images
  	  slickSlider.slick('slickFilter', function() { return false });
      
      return $.Deferred(function (dfd) {
        stubbleVariants.is_running = true;
        stubbleVariants.ImagesShownPromises = [];
        var customSelector = '#ProductThumbs';

        //register VariantChange Event
        stubbleVariants.registerSelectChange();

        //Dont do anything if no mapping is provided
        if (stubbleVariants.urlParam('variant') != null) {
          if (stubbleVariants.variants[stubbleVariants.urlParam('variant')] == null || stubbleVariants.variants[stubbleVariants.urlParam('variant')].length == 0) {
            return;
          }
        }
        else {
          if (stubbleVariants.variants[stubbleVariants.defaultVariant] == undefined || stubbleVariants.variants[stubbleVariants.defaultVariant].length == 0) {
            return;
          }
        }


        //initial FadeOut
        if ($(customSelector).children('img').length > 0) {
          $toFadeOut = $(customSelector).children('img:visible');
        }
        else {
          $toFadeOut = $(customSelector).find('img').parentsUntil(customSelector, ':visible');
        }
        var shown = false;
        $toFadeOut.fadeOut(150).promise().done(function () {
          if (!shown) {
            showVariantImages(stubbleVariants.urlParam('variant'));
            shown = true;

            $.when.apply(null, stubbleVariants.ImagesShownPromises).done(function () {
              if (typeof stubbleVariants.VariantChangeCallback != 'undefined') {
                stubbleVariants.VariantChangeCallback();
              }
              $(document).trigger("VIP:FilterComplete");
              stubbleVariants.is_running = false;
            });
          }
          $(document).trigger("VIP:InitComplete");
          dfd.resolve();
        });
      }).promise();
    }



    var showVariantImages = function (variantId) {
      if (variantId != null) {
        //var valueSelected = variantName.toLowerCase();
        var imagesToSelect = stubbleVariants.variants[variantId];
        var imagesArray = imagesToSelect.split(",");
        imagesArray.forEach(showVariantImage);
      }
      else {
        var imagesToSelect = stubbleVariants.variants[stubbleVariants.defaultVariant];
        var imagesArray = imagesToSelect.split(",");
        imagesArray.forEach(showVariantImage);
      }
    }
    var showVariantImagesForProduct = function (variantId, productId) {
      if (variantId != null) {
        //var valueSelected = variantName.toLowerCase();
        var imagesToSelect = stubbleVariants.all_mappings[productId][variantId];
        var imagesArray = imagesToSelect.split(",");
        imagesArray.forEach(showVariantImage);
      }
      else {
        var imagesToSelect = stubbleVariants.all_mappings[productId][stubbleVariants.defaultVariant];
        var imagesArray = imagesToSelect.split(",");
        imagesArray.forEach(showVariantImage);
      }
    }

    stubbleVariants.showAllVariantImages = function () {
      var customSelector = '#ProductThumbs';

      if ($(customSelector).children('img').length > 0) {
        $(customSelector).children('[data-image-id]').fadeIn(200);
      }
      else {
        $(customSelector).find('[data-image-id]').parentsUntil(customSelector).fadeIn(200);
      }

    }

    //<20.02.2017> New Event Mechanism-------------------------------------------
    stubbleVariants.registerSelectChange = function () {
      //get all select elements and check options for values
      var variantIDs = Object.keys(stubbleVariants.variants);
      var selects = $('select');
      var variantSelect = findVariantSelect(variantIDs, selects);
      if (variantSelect != undefined) {
        console.log("variantSelect found. Registering change event.");
        var lastVal = variantSelect.val();
        if (typeof stubbleVariants.triggerInterval == 'undefined') {
          stubbleVariants.triggerInterval = setInterval(function () {
            var newVal = variantSelect.val();
            if (newVal !== lastVal) {
              // it changed, fire an event or process it
              variant = { id: newVal };
              $(document).trigger({
                type: 'variantImageChange',
                variant: variant,
                internalVIPTrigger: true
              });
            }
            lastVal = newVal;
          }, 500);
        }
      }
    }

    //HELPER FUNCTIONS
    /* From Modernizr */
    stubbleVariants.whichTransitionEvent = function () {
      var t;
      var el = document.createElement('fakeelement');
      var transitions = {
        'transition': 'transitionend',
        'OTransition': 'oTransitionEnd',
        'MozTransition': 'transitionend',
        'WebkitTransition': 'webkitTransitionEnd'
      }

      for (t in transitions) {
        if (el.style[t] !== undefined) {
          return transitions[t];
        }
      }
    }

    var findVariantSelect = function (variantIDs, selects) {
      var variantSelect = undefined;

      selects.each(function (index, element) {
        var options = $(element).children('option'),
          isVariantSelect = false;

        options.each(function (index, element) {
          if (variantIDs.indexOf($(element).val()) >= 0) {
            isVariantSelect = true;
          }
        });
        if (isVariantSelect) {
          variantSelect = $(element);
        }
      });
      return variantSelect;
    }

    var showVariantImage = function (element, index, array) {
      var customSelector = '#ProductThumbs';

      if (stubbleVariants.currentSelector != undefined) {
        customSelector = stubbleVariants.currentSelector;
      }


      if ($(customSelector).children('img').length > 0) {
        stubbleVariants.ImagesShownPromises.push($(customSelector).children('[data-image-id=' + element + '] img,[data-image-id=' + element + ']').fadeIn(200).promise());
      }
      else {
        stubbleVariants.ImagesShownPromises.push($(customSelector).find('[data-image-id=' + element + '] img,[data-image-id=' + element + ']').parentsUntil(customSelector).fadeIn(200).promise());
      }
    }

    stubbleVariants.urlParam = function (e) { var t = RegExp("[?&]" + e + "=([^&#]*)").exec(window.location.search); return t && decodeURIComponent(t[1].replace(/\+/g, " ")) }
    //TODO: fix init running twice when script included twice
    //init when mapping loaded
    stubbleVariants.variantsInfoReady.done(function () {
      if (false) {
        stubbleVariants.initDone = init();
        $(window).trigger('resize');
        stubbleVariants.is_running = false;
      }
    });
    
    // Define a function for filtering product images by variant
    function filterVariantImages (variantID) {      
	  // Unfilter first to show all
      slickSlider.slick('slickUnfilter');

      // If stubbleVariants is not loaded or there are no stubbleVariants variants then just return now
      if (!stubbleVariants || !stubbleVariants.variants || Object.keys(stubbleVariants.variants).length === 0) return

      // Get list of images for this variant
      let images = stubbleVariants.variants[variantID] || [];

      // Filter slides and keep array of indecies that match
      let matches = [];
      slickSlider.slick("slickFilter", function (idx) {
        // Get the image ID of this slide
        let imageId = $(this).find('img').data('image-id');

        // Check if it should be shown or not
        let imgShouldBeShown = images.indexOf(imageId) !== -1;
        if (imgShouldBeShown) matches.push(idx);

        return imgShouldBeShown;
      })

      // Set the first valid image to active
      setTimeout(function () {
        slickSlider.slick('slickGoTo', 0, false);
      }, 200);
      
      // Set the last variant ID
      stubbleVariants.lastVariantID = variantID;
    }

    stubbleVariants.lastVariantID = null;
    
    if (!window.productIsPrelaunch) {
      setInterval(function () {
        // Check if the interval ID has changed
        var variantID = $('#ProductSelect-product').val();
        var hasChanged = variantID !== stubbleVariants.lastVariantID;
        var hasVariants = typeof stubbleVariants.variants != 'undefined' && Object.keys(stubbleVariants.variants).length

        // If the variant has changed then filter the product images
        if (hasVariants && hasChanged) {
          console.log("Variant Changed from "+stubbleVariants.lastVariantID+" to "+variantID);
          filterVariantImages(variantID);

          $('span#sticky-bottom-variant-text').text($('#SingleOptionSelector-product-0').val())

          // Send event to Facebook
  //         fbq('track', 'ViewContent', {
  //           content_ids: 'item-' + variantID,
  //           content_type: 'product',
  //         });
        }
      }, 500)
    }

    stubbleVariants.loaded = true
    $('.image-column').css("opacity", 1);
    $(document).trigger("VIP:Ready");

  }(stubbleVariants, jQuery));
});